import { Component, OnInit, Input, Output, Inject, EventEmitter } from '@angular/core';
import { Router } from "@angular/router";
import { environment } from '../../../environments/environment';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CurrentUser } from '../../security/current-user.model';
import { CurrentUserService } from "../../security/current-user.service";
import { FacetedSearchAppService } from '../webapi/faceted-search-app.service';
import { FormControl, FormGroupDirective, NgForm, Validators, FormGroup } from '@angular/forms';
import { SearchCriteria } from '../webapi/faceted-search-app.model';

@Component({
  selector: 'preset',
  templateUrl: 'preset.component.html',
  styleUrls: ['preset.component.css']
})
export class PresetComponent {

  constructor(
    private currentUserService: CurrentUserService,
    private facetedSearchAppService: FacetedSearchAppService) {
  }

  @Input()
  name: string;

  @Input()
  value: string;

  select() {
    this.facetedSearchAppService.currentSearchCriteria = SearchCriteria.fromString(this.value);
    this.facetedSearchAppService.search();
  }


  ngOnInit(): void {
    console.log("preset: init");
    console.log("name=" + this.name + " value=" + this.value);
  }

}




// WEBPACK FOOTER //
// ./src/app/fsapplication/preset/preset.component.ts